module.exports = __webpack_public_path__ + "static/media/foreign-language-courses-in-delhi-university.28e39d0b.jpeg";